import { css } from "lit";
export default css `
    :host {
        display: block;
        height: 100%;
        width: 100%;
    }
    #container {
        height: 100%;
        width: 100%;
        position: relative;
    }
    #box-content{
        position: absolute;
        z-index: 10;
        padding: 5px;
        //width: 100%;
        height: 100%;
    }
    svg {
        z-index: 11;
    }
`;
